import React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

// Note: This is a CRA/React app (not Next.js). next-themes still works
// for toggling a `class` on <html>. We keep a dark-first palette even
// in "light" mode to align with the site's dark premium identity.

export default function ThemeProvider({ children }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      themes={["dark", "light"]}
    >
      {children}
    </NextThemesProvider>
  );
}
